/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useRouteMatch } from "react-router-dom";
import { withRouter } from "react-router-dom";
import TablePagination from "@material-ui/core/TablePagination";
import {
  getFilterVacancies,
  applyToVacant,
} from "../../actions/vacant-actions";
import { useStateValue } from "../../context/store";
import { headers } from "./models";
import ModalConfirmBaseComment from "../../utils/form/modalConfirmBaseComment";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import {
  Backdrop,
  CircularProgress,
  Typography,
} from "@material-ui/core";
import DetailedAccordionVacancies from "./detailedAccordionVacancies";
import { getById } from "../../actions/user-actions";
import SearchVacancie from "./searchVacancie";
import Utils from "../../utils/utils";
import Search from "../../images/icons/search.svg";
import { getValidateCvByDocumentAndType } from "../../actions/cv-actions";
import { ERROR_MESSAGE } from "../../constants";
import { permissionsConstans } from "../../constansPermissions";
import { getContractTypesValues } from "../../actions/contract-type-actions";
import { useQuery } from "react-query";
const _ = require("lodash");

const Vacancies = (props) => {
  const [{ filterVacant, breadCrumb, sessionUser }, dispatch] = useStateValue();
  const [isLoading, setIsLoading] = useState(false);
  const [hasCv, setHasCv] = useState(false);
  const [person, setPerson] = useState(null);
  const [permissionsVacancies, setPermissionsVacancies] = useState([]);

  const [message, setMessage] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    type: "",
  });
  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    type: "",
  });

  const [filter, setFilter] = useState({
    initDate: null,
    endDate: null,
    minSalary: null,
    maxSalary: null,
    contractType: null,
    regional: null,
  });

  const [paginadorRequest, setPaginadorRequest] = useState({
    page: 0,
    size: 10,
    order: "DESC",
    columnOrder: "creationDate",
  });

  const [paginadorResponse, setPaginadorResponse] = useState({
    data: [],
    totalRows: 0,
    pageSize: 0,
    pageNumber: 0,
  });

  const getListContractTypes = async () => {
    const resp = await getContractTypesValues();
    let orderContractTypes = _.sortBy(
      resp && resp.data,
      (o) => o.contractTypeDescription
    );
    return orderContractTypes;
  };


  const { data: dataContract, status: statusListContractType } = useQuery(
    "listContractType",
    getListContractTypes
  );
  const changePage = (event, nuevaPagina) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      page: parseInt(nuevaPagina),
    }));
  };

  const changeAmountOfRecords = (event) => {
    setPaginadorRequest((anterior) => ({
      ...anterior,
      size: parseInt(event.target.value),
      page: 0,
    }));
  };

  const getUser = () => {
    const data = JSON.parse(localStorage.getItem("state"));
    return sessionUser ? sessionUser : data;
  };

  const [user, setUser] = useState(getUser());

  const getVacants = async () => {
    var d = new Date();
    d.setHours(0, 0, 0, 0);

    var initDate = filter.initDate
      ? Utils.getFormattedDateyyyyMMdd(filter.initDate, "-")
      : null;

    const response = await getFilterVacancies(
      {
        initDate: initDate,
        endDate: filter.endDate
          ? filter.endDate.toISOString().split("T")[0]
          : d.toISOString().split("T")[0],
        minSalary: filter.minSalary === "" ? null : filter.minSalary,
        maxSalary: filter.maxSalary === "" ? null : filter.maxSalary,
        contractType: filter.contractType === "" ? null : filter.contractType,
        regional: filter.regional === "" ? null : filter.regional,
        personId : user?.userInfo?.person?.id,
      },
      {
        page: paginadorRequest.page,
        size: paginadorRequest.size,
        order: paginadorRequest.order,
        columnOrder: paginadorRequest.columnOrder,
      },
      dispatch
    );
    if (response.data) {
      const data = response.data.vacantResponsePage;
      if (data.content?.length > 0) {
        setPaginadorResponse({
          data: data.content,
          totalRows: data.totalElements,
          pageSize: data.size,
          pageNumber: data.number,
        });
      }
    } else {
      setPaginadorResponse({
        data: [],
        totalRows: 0,
        pageSize: 0,
        pageNumber: 0,
      });
    }
  };

  useEffect(() => {
    getVacants();
    const responsePersmissions = Utils.validationPermissions("VAC");
    setPermissionsVacancies(responsePersmissions);
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Vacantes",
      breadCrumbSubText: "Vacantes",
      index: 7,
    });
  }, [paginadorRequest]);


  if (
    filterVacant &&
    filterVacant?.isFilter &&
    filter !== filterVacant.filter
  ) {
    var newfilter = filterVacant.filter;
    filter.initDate = newfilter.initDate;
    filter.endDate = newfilter.endDate;
    filter.minSalary = newfilter.minSalary;
    filter.maxSalary = newfilter.maxSalary;
    filter.contractType = newfilter.contractType;
    filter.regional = newfilter.regional;
    paginadorRequest.page = 0;
    getVacants();
    dispatch({
      type: "SET_VACANCY_FILTER",
      isFilter: false,
    });
  }

  const closeMessage = () => {
    setMessage((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
  };

  const getCurriculum = (data) => {
    const getCv = async () => {
      const cvResponse = await getValidateCvByDocumentAndType(
        data.documentNumber,
        data.documentType,
        dispatch
      );
      let type = Utils.encrypt(data.documentType);
      let document = Utils.encrypt(data.documentNumber);
      const cv = cvResponse.data;
      if (cv) {
        setHasCv(true);
      } else {
        setHasCv(false);
      }
    };
    getCv();
  };

  useEffect(() => {
    const getPerson = async () => {
      const data = JSON.parse(localStorage.getItem("state"));
      let personId = sessionUser && sessionUser.userInfo.person.id;
      let id = personId ? personId : data.userInfo.person.id;
      const personResponse = await getById(id, dispatch);
      setPerson(personResponse.data);
      const persona = personResponse.data;
      if (persona) {
        getCurriculum(persona);
      }
    };

    getPerson();
  }, []);

  const applyVacant = async (vacantId) => {
    if (!hasCv) {
      setMessage(() => ({
        open: true,
        question: "¿Desea Registrar hoja de vida?",
        handleClick: () => props.history.push(`/dashboard/hoja-vida/crear`),
        handleClickOut: closeMessage,
        buttonOneText: "ACEPTAR",
        type: "QUESTION",
        title: "Aplicar Vacante",
      }));
      return;
    }
    let userId = user?.userInfo?.person?.id;
    setIsLoading(true);
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
    }));
    let body = {
      vacant: vacantId,
      person: userId,
    };
    const response = await applyToVacant(body, dispatch);
    if (
      response &&
      (response.status === 200 ||
        response.status === 201 ||
        response.status === 202)
    ) {
      setIsLoading(false);
      setMessage({
        open: true,
        question: "Señor usuario, su postulación fue exitosa",
        type: "SUCCESS",
        handleClickOut: closeMessage,
        handleClick: closeMessage,
        oneButtons:true,
      });
      getVacants();
    } else {
      setIsLoading(false);
      dispatch({
        type: "OPEN_SNACKBAR",
        openMessage: {
          open: true,
          message: "Señor usuario, ya ha aplicado a esta vacante",
        },
      });
      closeMessage();
    }
  };

  const applyVacantConfirm = (id) => {
    setMessage(() => ({
      open: true,
      question: "¿Está seguro que desea aplicar a esta vacante?",
      handleClick: () => applyVacant(id),
      handleClickOut: closeMessage,
      buttonOneText: "ACEPTAR",
      type: "QUESTION",
      title: "Aplicar Vacante",
    }));
  };

  const validationPermissionSearch = () => {
    if (
      permissionsVacancies?.functionalities?.some(
        (x) => x === permissionsConstans.ROL_EDITAR
      )
    ) {
      return <SearchVacancie />;
    }
  };

  return (
    <div style={{ marginTop: "15px" }}>
      <Backdrop style={{ zIndex: "9999" }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <ModalConfirmBase
        open={message.open}
        description={message.question}
        handleClickOut={message.handleClickOut}
        handleClick={message.handleClick}
        textButtonSubmit={message.buttonOneText}
        type={message.type}
        oneButtons={message.oneButtons}
      />
      <ModalConfirmBaseComment
        open={confirm.open}
        description={confirm.question}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
        textButtonSubmit={confirm.buttonOneText}
        type="QUESTION"
      />
      <SearchVacancie />
      {paginadorResponse.data.map((row, index) => (
        <DetailedAccordionVacancies
          headers={headers}
          data={row}
          dataContract={dataContract}
          statusListContractType={statusListContractType}
          //onView={verRequisicion}
          onApply={applyVacantConfirm}
        />
      ))}
      {paginadorResponse.totalRows !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={paginadorResponse.totalRows}
          rowsPerPage={paginadorRequest.size}
          page={paginadorRequest.page}
          onChangePage={changePage}
          onChangeRowsPerPage={changeAmountOfRecords}
          labelRowsPerPage="Registros por página"
        />
      ) : (
        <div>
          <div
            style={{
              justifyContent: "center",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "10%",
              display: "flex",
            }}
          >
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado.
            </Typography>
          </div>
        </div>
      )}
    </div>
  );
};

export default withRouter(Vacancies);
